/*
 * Copyright (c) 2022 Well Solutions SRL. All Rights Reserved.
 * This software is the proprietary information of Well Solutions SRL.
 * Use is subject to license and non-disclosure terms
 */

import {RoleDefinitionDto} from "./role-definition-dto.model";
import {RoleRightDefinitionDto} from "./role-right-definition-dto.model";

export class RoleWithRightsDto extends RoleDefinitionDto{
  roleRights: RoleRightDefinitionDto[] | undefined = undefined;
}
